/* trackingTemplateCompanies.component.js */

import trackingTemplateCompaniesController from "./trackingTemplateCompanies.controller";

/**
 * @desc component for selecting companies to associate to a role for an IM request
 * @example <tracking-template-companies></tracking-template-companies>
 */

const trackingTemplateCompanies = {
    bindings: {
        selectedTemplate: '<',
        productId: '<',
        availableCompanies: '<'
    },
    controller: trackingTemplateCompaniesController,
    controllerAs: 'ttcvm',
    templateUrl: '/App/Components/TemplateTracking/trackingTemplateCompanies/trackingTemplateCompanies.tmpl.html'
};

export default trackingTemplateCompanies;